export default __webpack_public_path__ + "i18n/translations/translation-zh.bbf99f0a.json";